import React, { useEffect, useState, useRef } from 'react';
import { Button, Input, InputRed, LayerBottom, Toast, InputTimer } from 'components'
import useApp from 'hooks/useApp'
import { useNavigate, useLocation } from 'react-router-dom'
import Lib from 'library'

const JoinNumber = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)
	const location = useLocation()
	const navigate = useNavigate()

	const [info, setInfo] = useState()
	const [showToast, setShowToast] = useState()
	const [buttonDisabled, setButtonDisabled] = useState(true)
	const [showRed, setShowRed] = useState(false)
	const [timerStart, setTimerStart] = useState(false) // 타이머 스타트 여부
	const [certTimout] = useState(180) // 인증번호 입력 시간 제한, 초
	const [certNumber, setCertNumber] = useState("")

	const input = useRef()

	// 인증번호 입력 시간 초과
	const onTimerComplete = () => {
		setShowRed(true)
	}

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	const sendCertNumber = () => {
		Lib.post({
			url: `/api/mb/join/auth/req`,
			data: {
				cphNo: info.cphNo,
				nm: info.nm,
				rsdtRegNo: info.rsdtRegNo,
				tcomCd: info.tcomCd
			},
			onSuccess: onSuccess,
			onError: error => {
				App.alert(`${error}`)
			}
		})
	}

	const onSuccess = data => {
		window.setTimeout(() => {
			setShowToast(true)
		}, 300)
		setCertNumber("")
		setButtonDisabled(true)
		input.current.focus()
		setTimerStart(true)
		setShowRed(false)
	}

	const resend = () => {
		sendCertNumber()
	}

	const onNext = () => {
		Lib.post(`/api/mb/join/auth/verify`, {
			authNo: certNumber
		}, data => {
			if (data.regrdYn === "Y") {
				window.localStorage.setItem("mbId", data.mbId)
				window.localStorage.setItem("useBio", data.bioAuthUseYn === "Y" ? true : false)
				App.alert("이미 가입이 되어있습니다. 로그인 해주세요.", () => {
					App.setDidRun(true)
					navigate("/member/login")
				})
			} else {
				navigate("/joinEmail")
			}
		})
	}

	useEffect(() => {
		if (info) {
			console.log(info)
			onSuccess()
		}
	}, [info])

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

		if (!location.state || !location.state.info) {
			App.alert("잘못된 접근입니다.", () => {
				navigate(-1)
			})
		} else {
			setInfo(location.state?.info)
		}

		

	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<h3>휴대폰으로 전송된<br />인증번호 6자리를 입력해주세요.</h3>

				<p className="guide-title mt_40">인증번호</p>
				<div className="mt_10 relative flex-align_center">
					<Input ref={input} type="tel" placeholder="인증번호 입력" value={certNumber} className="mr_10 pr_5 withBtn" maxlength="6" onChange={e => {
						const value = e.target.value
						setCertNumber(value)
						if (e.target.value.length >= 6) {
							setButtonDisabled(false)
						} else {
							setButtonDisabled(true)
						}
					}} />
					<InputTimer start={timerStart} setStart={setTimerStart} duration={certTimout} onComplete={onTimerComplete} />
					<Button className="btn btn--sm btn--light-blue nowrap" style={{ fontSize: "1.2rem" }} onClick={resend}>재전송</Button>

				</div>

				{/* 오류메세지 출력 시 Input focus border 레드 컬러로 */}
				<InputRed text="인증번호 입력시간이 초과되었어요. 재전송을 통해 인증번호를 다시 받고 입력해주세요." show={showRed} />

				<p className="btn-text mt_20"><span onClick={openLayer}>인증번호가 오지 않나요?</span></p>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" disabled={buttonDisabled} onClick={onNext}>다음</Button>
			</div>

			<ConfirmLayer show={showLayer} closeLayer={closeLayer} />

			<Toast show={showToast} setShow={setShowToast} text="인증번호가 발송되었습니다." />
		</div>
	)
}

const ConfirmLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="인증번호가 오지 않나요?" show={show} closeLayer={closeLayer}>
			<div className="layer-text">
				<p>‘스팸차단 서비스’로 인증번호 수신이 어려울 수 있습니다.<br />
					전화 &gt; 더보기 &gt; 설정 &gt; 수신차단 목록에서 SMS 인증 발신번호를 제외 해주세요.</p>
				<p className="mt_20">통신사 ‘명의도용알림 서비스’로 인증번호 수신이 어려울 수 있습니다. 통신사에 직접 문의하여 해지해주세요.</p>
			</div>
		</LayerBottom>
	)
}

export default JoinNumber